import {Directive, ElementRef, EventEmitter, Input, Output} from '@angular/core';

@Directive({
    selector: '[delayIonChange]',
    host: {
        '(ionChange)': 'timeoutChange($event)'
    }
})
export class DelayIonChangeDirective {

    private timeout: number;

    @Input('delay') delay: number = 700;

    @Output('delayIonChange') change:EventEmitter<any> = new EventEmitter();

    constructor(public element: ElementRef) {

    }

    timeoutChange(event) {

        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {

            this.change.emit(event);

        }, this.delay);

    }

}



// WEBPACK FOOTER //
// ./src/directives/delay-ion-change.ts